(function(e, a) { for(var i in a) e[i] = a[i]; }(exports, /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _FoursquareProxyClient = __webpack_require__(2);

	Object.defineProperty(exports, 'FoursquareProxyClient', {
	  enumerable: true,
	  get: function get() {
	    return _FoursquareProxyClient.FoursquareProxyClient;
	  }
	});

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.FoursquareProxyClient = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _CommonProtocolClient = __webpack_require__(3);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var FoursquareProxyClient = exports.FoursquareProxyClient = function () {
		function FoursquareProxyClient(_ref) {
			var XMLHttpRequest = _ref.XMLHttpRequest,
			    _ref$endpointUrl = _ref.endpointUrl,
			    endpointUrl = _ref$endpointUrl === undefined ? 'https://apps.wixrestaurants.com/foursquare/' : _ref$endpointUrl,
			    _ref$timeout = _ref.timeout,
			    timeout = _ref$timeout === undefined ? 0 : _ref$timeout;

			_classCallCheck(this, FoursquareProxyClient);

			this._client = new _CommonProtocolClient.CommonProtocolClient({ XMLHttpRequest: XMLHttpRequest, endpointUrl: endpointUrl, timeout: timeout });
		}

		_createClass(FoursquareProxyClient, [{
			key: 'api',
			value: function api(_ref2) {
				var path = _ref2.path,
				    params = _ref2.params;

				return this._client.doRequest('api', { path: path, params: params });
			}
		}]);

		return FoursquareProxyClient;
	}();

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var CommonProtocolClient = exports.CommonProtocolClient = function () {
		function CommonProtocolClient(_ref) {
			var XMLHttpRequest = _ref.XMLHttpRequest,
			    endpointUrl = _ref.endpointUrl,
			    timeout = _ref.timeout;

			_classCallCheck(this, CommonProtocolClient);

			this.XMLHttpRequest = XMLHttpRequest;
			this.endpointUrl = endpointUrl;
			this.timeout = timeout || 0;
		}

		_createClass(CommonProtocolClient, [{
			key: 'doRequest',
			value: function doRequest(resource, request) {
				var _this = this;

				return new Promise(function (resolve, reject) {
					var xhr = new _this.XMLHttpRequest();
					xhr.ontimeout = function () {
						return reject({
							code: 'timeout',
							description: 'request timed out'
						});
					};
					xhr.onerror = function () {
						return reject({
							code: 'network_down',
							description: 'network is down'
						});
					};
					xhr.onload = function () {
						try {
							var response = JSON.parse(xhr.responseText);
							if (response.error) {
								reject(response.error);
							} else {
								resolve(response.value);
							}
						} catch (e) {
							reject({
								code: 'protocol',
								description: 'unexpected response format'
							});
						}
					};

					xhr.open('POST', _this.endpointUrl + resource, true);
					xhr.timeout = _this.timeout;
					xhr.setRequestHeader('Content-Type', 'application/json');
					xhr.send(JSON.stringify(request));
				});
			}
		}]);

		return CommonProtocolClient;
	}();

/***/ })
/******/ ])));